import React from 'react';
import {
  BasicPreloader,
  BoundedContent,
  GridContainer,
  Row,
  Typography,
  Button,
} from '@vp/swan';
import { Link as RouterLink } from '@reach/router';
import useIdentityContext from '../../../hooks/useIdentityContext';
import TitlePanel from './TitlePanel';

const ResubmissionMain = () => {
  const { identity } = useIdentityContext();
  const { isSignedIn } = identity;

  return isSignedIn ? (
    <BoundedContent>
      <GridContainer>
        <Row>
          <TitlePanel />
        </Row>
        <Row>
          <Typography component="h4" mt={5} mb={5}>
            Please resubmit your orders:
          </Typography>
        </Row>
        <Row mb={5}>
          <Button
            skin="primary"
            sizeVariant="standard"
            widthVariant="standard"
            hasIcon
            iconPosition="right"
            mr={2}
          >
            <RouterLink to="/orderResubmission">
              Resubmit Orders Via CSV File
            </RouterLink>
          </Button>
        </Row>
      </GridContainer>
    </BoundedContent>
  ) : (
    <BasicPreloader sizeVariant="large" centered my={6} />
  );
};

export default ResubmissionMain;
